import { render, staticRenderFns } from "./SimpleUploaderComponent.vue?vue&type=template&id=192a04e4&"
import script from "./SimpleUploaderComponent.vue?vue&type=script&lang=js&"
export * from "./SimpleUploaderComponent.vue?vue&type=script&lang=js&"
import style0 from "./SimpleUploaderComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports